module.exports = __webpack_public_path__ + "img/note.d3bb2995.svg";